<div class="maintenance-container">
    <div class="container">
        <div class="row justify-content-center align-items-center min-vh-100">
            <div class="col-12 col-md-8 col-lg-6 col-xl-5">
                <div class="card card-maintenance shadow-lg">
                    <div class="card-body text-center p-5">
                        <div class="maintenance-icon mb-4">
                            <i class="fa fa-cog fa-spin fa-4x text-success"></i>
                        </div>
                        <h1 class="maintenance-title mb-3">
                            Sistema em Manutenção
                        </h1>
                        <p class="maintenance-message text-muted mb-4">
                            Estamos realizando melhorias no sistema para oferecer uma experiência ainda melhor.
                            Por favor, tente novamente em alguns instantes.
                        </p>
                        <div class="mb-4">
                            <button
                                type="button"
                                class="btn btn-primary btn-lg px-5"
                                (click)="reloadPage()">
                                <i class="fa fa-refresh"></i>
                                <span class="ml-2">Tentar Novamente</span>
                            </button>
                        </div>
                        <div class="maintenance-info mt-4 pt-4 border-top">
                            <p class="small text-muted mb-0">
                                <i class="fa fa-info-circle"></i>
                                Você será redirecionado automaticamente quando o sistema estiver disponível.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="text-center mt-4">
                    <p class="text-muted small mb-0">
                        Food Checker
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

